import { render } from "./MainSponsors.vue?vue&type=template&id=cf6e0b3a&scoped=true"
import script from "./MainSponsors.vue?vue&type=script&lang=js"
export * from "./MainSponsors.vue?vue&type=script&lang=js"

import "./MainSponsors.vue?vue&type=style&index=0&id=cf6e0b3a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/vizbi-frontend-test/vizbi-frontend-test/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf6e0b3a"]])

export default __exports__